import { frontendURL } from '../../../helper/URLHelper';
import ContactsIndex from './pages/ContactsIndex.vue';
import ContactManageView from './pages/ContactManageView.vue';
import ChatRecord from './pages/ChatRecord.vue';
import PushLayout from './pages/push/PushLayout.vue';
import PushConfig from './pages/push/PushConfig.vue';
import PushUnpushed from './pages/push/PushUnpushed.vue';
import PushLog from './pages/push/PushLog.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'contact_manage'],
};

// 名片推送: 仅 administrator
const pushMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts'),
    component: ContactsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'contacts_dashboard_index',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'segments/:segmentId',
        name: 'contacts_dashboard_segments_index',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'labels/:label',
        name: 'contacts_dashboard_labels_index',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'active',
        name: 'contacts_dashboard_active',
        component: ContactsIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/contacts/:contactId'),
    component: ContactManageView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'contacts_edit',
        component: ContactManageView,
        meta: commonMeta,
      },
      {
        path: 'segments/:segmentId',
        name: 'contacts_edit_segment',
        component: ContactManageView,
        meta: commonMeta,
      },
      {
        path: 'labels/:label',
        name: 'contacts_edit_label',
        component: ContactManageView,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/push'),
    component: PushLayout,
    meta: pushMeta,
    children: [
      {
        path: 'config',
        name: 'push_config',
        component: PushConfig,
        meta: pushMeta,
      },
      {
        path: 'unpushed',
        name: 'push_unpushed',
        component: PushUnpushed,
        meta: pushMeta,
      },
      {
        path: 'log',
        name: 'push_log',
        component: PushLog,
        meta: pushMeta,
      },
    ],
  },
  {
    // 定制: 会话记录h5页(尘锋「易聊-对话记录」字段链接目标, 需登录后台)
    path: frontendURL('accounts/:accountId/chat_records/:contactId'),
    name: 'chat_record',
    component: ChatRecord,
    meta: commonMeta,
  },
];
